import graphql from 'babel-plugin-relay/macro';
import {FormikHelpers} from 'formik';
import React from 'react';
import {useMutation} from 'react-relay/hooks';
import {useHistory} from 'react-router';
import ConnectionHandler from 'relay-connection-handler-plus';
import {showEventNotification} from 'src/utils/notifications';
import {withSuspense} from 'src/utils/withSuspense';

import Form from '../components/Form';
import {FormValues} from '../types';
import {createPageCreateGeneralAssetFamilyMutation} from './__generated__/createPageCreateGeneralAssetFamilyMutation.graphql';

function CreatePage() {
  const history = useHistory();

  const [commit, isInFlight] = useMutation<createPageCreateGeneralAssetFamilyMutation>(
    createGeneralAssetFamilyMutation,
  );

  return (
    <Form
      title="Create General Asset Type"
      button="Create General Asset Type"
      onSubmit={handleSubmit}
      isSubmitting={isInFlight}
    />
  );

  function handleSubmit(input: FormValues, formikHelpers: FormikHelpers<FormValues>) {
    commit({
      variables: {input},
      onCompleted: payload => {
        if (
          payload.createGeneralAssetFamily?.errors[0] &&
          payload.createGeneralAssetFamily?.errors[0].fields
        ) {
          payload.createGeneralAssetFamily?.errors[0].fields.forEach(fieldError => {
            formikHelpers.setFieldError(fieldError.fieldName, fieldError.message);
          });
        }

        const entry = payload.createGeneralAssetFamily?.generalAssetFamily;

        if (entry) {
          showEventNotification('added', 'Type', entry.name);
          return history.push('/admin/general_asset_types');
        }
      },
      updater: store => {
        const root = store.getRoot();

        const connectionRecords = ConnectionHandler.getConnections(
          root,
          'GeneralAssetFamiliesList_generalAssetFamilies',
        );

        if (!connectionRecords) {
          return;
        }

        const payload = store.getRootField('createGeneralAssetFamily');

        if (!payload) {
          return;
        }

        const newRecord = payload.getLinkedRecord('generalAssetFamily');

        if (!newRecord) {
          return;
        }

        connectionRecords.forEach(connectionRecord => {
          const newEdge = ConnectionHandler.createEdge(
            store,
            connectionRecord,
            newRecord,
            'generalAssetFamilyEdge',
          );

          ConnectionHandler.insertEdgeAfter(connectionRecord, newEdge);
        });
      },
    });
  }
}

const createGeneralAssetFamilyMutation = graphql`
  mutation createPageCreateGeneralAssetFamilyMutation($input: CreateGeneralAssetFamilyInput!) {
    createGeneralAssetFamily(input: $input) {
      generalAssetFamily {
        id
        createdAt
        name
      }
      errors {
        code
        fields {
          fieldName
          message
        }
      }
    }
  }
`;

export default withSuspense(CreatePage);
